import React from "react"
import { ButtonIcon } from "../types/buttonCustomization"

export const getButtonIconSVG = (
  iconType: ButtonIcon,
  _color: string = "white"
): React.ReactNode => {
  const svgStyle = { width: "100%", height: "100%", display: "block" }

  switch (iconType) {
    case ButtonIcon.TINT_LOGO:
      return (
        <svg
          width="70"
          height="30"
          viewBox="0 0 70 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5336 4.99671V10.1817H15.1011V15.4034H10.5336V22.0225C10.5336 22.7334 10.7239 23.2912 11.1045 23.6957C11.4852 24.1002 11.9947 24.3024 12.6332 24.3024C13.4436 24.3024 14.1557 24.094 14.7696 23.6773L16.5009 28.5681C15.9115 28.9358 15.1932 29.2177 14.346 29.4138C13.4988 29.6099 12.5964 29.708 11.6386 29.708C9.03564 29.708 7.03428 29.0706 5.63455 27.7958C4.23482 26.521 3.53496 24.6211 3.53496 22.096L3.53496 15.4034H0.625L0.625 10.1817H3.53496L4.69342 4.99671H10.5336ZM63.4077 4.99671V10.1817L67.9753 10.1817V15.4034L63.4077 15.4034V22.0225C63.4077 22.7334 63.598 23.2912 63.9787 23.6957C64.3593 24.1002 64.8689 24.3024 65.5073 24.3024C66.3177 24.3024 67.0298 24.094 67.6438 23.6773L69.375 28.5681C68.7856 28.9358 68.0674 29.2177 67.2202 29.4138C66.3729 29.6099 65.4705 29.708 64.5128 29.708C61.9098 29.708 59.9084 29.0706 58.5087 27.7958C57.109 26.521 56.4091 24.6211 56.4091 22.096V15.4034H53.4991V10.1817H56.4091L57.5676 4.99671H63.4077ZM26.2195 9.44621V29.377H19.2209V9.44621H26.2195ZM43.231 9.11525C45.7112 9.11525 47.7065 9.85071 49.2167 11.3216C50.7269 12.7925 51.482 15.0112 51.482 17.9775V29.377H44.4834V19.1174C44.4834 16.3963 43.3906 15.0357 41.2051 15.0357C40.0018 15.0357 39.038 15.4279 38.3135 16.2124C37.5891 16.9969 37.2269 18.1736 37.2269 19.7426V29.377H30.2283V9.44621H36.1231L36.8954 11.6158C37.6812 10.8068 38.6144 10.1878 39.6949 9.75878C40.7753 9.32976 41.9541 9.11525 43.231 9.11525ZM22.7222 0.0205078C24.8773 0.0205078 26.6243 1.68189 26.6243 3.73132C26.6243 5.78074 24.8773 7.44213 22.7222 7.44213C20.5672 7.44213 18.8202 5.78074 18.8202 3.73132C18.8202 1.68189 20.5672 0.0205078 22.7222 0.0205078Z"
            fill="url(#paint0_radial_9838_30073)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_9838_30073"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(5.49021 4.02209) rotate(13.1541) scale(59.4909 32.8615)"
            >
              <stop stopColor="#FF9711" />
              <stop offset="0.318477" stopColor="#FF538E" />
              <stop offset="0.642822" stopColor="#B662FF" />
              <stop offset="1" stopColor="#1FA2FC" />
            </radialGradient>
          </defs>
        </svg>
      )

    case ButtonIcon.GLASSES:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <defs>
            <linearGradient id="glassesGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF9711" />
              <stop offset="33%" stopColor="#FF538E" />
              <stop offset="66%" stopColor="#B662FF" />
              <stop offset="100%" stopColor="#1FA2FC" />
            </linearGradient>
          </defs>
          <path
            d="M2 12C2 9.5 4 8 6.5 8S11 9.5 11 12s-2 4-4.5 4S2 14.5 2 12zm11 0c0-2.5 2-4 4.5-4S22 9.5 22 12s-2 4-4.5 4S13 14.5 13 12zm-2 0h2"
            stroke="url(#glassesGradient)"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      )

    case ButtonIcon.EYE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <defs>
            <linearGradient id="eyeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF9711" />
              <stop offset="33%" stopColor="#FF538E" />
              <stop offset="66%" stopColor="#B662FF" />
              <stop offset="100%" stopColor="#1FA2FC" />
            </linearGradient>
          </defs>
          <path
            d="M12 4C7 4 2.73 7.11 1 12c1.73 4.89 6 8 11 8s9.27-3.11 11-8c-1.73-4.89-6-8-11-8z"
            stroke="url(#eyeGradient)"
            strokeWidth="2"
            fill="none"
          />
          <circle
            cx="12"
            cy="12"
            r="3"
            stroke="url(#eyeGradient)"
            strokeWidth="2"
            fill="url(#eyeGradient)"
          />
        </svg>
      )

    case ButtonIcon.CAMERA:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <defs>
            <linearGradient id="cameraGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF9711" />
              <stop offset="33%" stopColor="#FF538E" />
              <stop offset="66%" stopColor="#B662FF" />
              <stop offset="100%" stopColor="#1FA2FC" />
            </linearGradient>
          </defs>
          <path
            d="M9 3h6l2 2h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4l2-2z"
            stroke="url(#cameraGradient)"
            strokeWidth="2"
            fill="none"
          />
          <circle cx="12" cy="13" r="4" stroke="url(#cameraGradient)" strokeWidth="2" fill="none" />
        </svg>
      )

    case ButtonIcon.CAMERA_BLACK:
      return (
        <svg
          width="18"
          height="15"
          viewBox="0 0 18 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <path
            d="M8.75 11.25C10.4759 11.25 11.875 9.85089 11.875 8.125C11.875 6.39911 10.4759 5 8.75 5C7.02411 5 5.625 6.39911 5.625 8.125C5.625 9.85089 7.02411 11.25 8.75 11.25Z"
            fill="black"
          />
          <path
            d="M15.625 2.50001H13.8975C13.7814 2.50038 13.6675 2.4682 13.5687 2.4071C13.4699 2.34601 13.3903 2.25846 13.3387 2.15439L12.7794 1.03626C12.6246 0.724101 12.3855 0.461553 12.0891 0.278394C11.7927 0.095235 11.4509 -0.00120508 11.1025 1.1367e-05H6.3975C6.04909 -0.00120508 5.7073 0.095235 5.41091 0.278394C5.11452 0.461553 4.87538 0.724101 4.72063 1.03626L4.15812 2.15439C4.10684 2.25799 4.02766 2.34522 3.9295 2.40628C3.83135 2.46734 3.7181 2.4998 3.6025 2.50001H1.875C1.37772 2.50001 0.900806 2.69756 0.549175 3.04919C0.197544 3.40082 0 3.87773 0 4.37501V13.125C0 13.6223 0.197544 14.0992 0.549175 14.4508C0.900806 14.8025 1.37772 15 1.875 15H15.625C16.1223 15 16.5992 14.8025 16.9508 14.4508C17.3025 14.0992 17.5 13.6223 17.5 13.125V4.37501C17.5 3.87773 17.3025 3.40082 16.9508 3.04919C16.5992 2.69756 16.1223 2.50001 15.625 2.50001ZM8.75 12.5C7.88471 12.5 7.03885 12.2434 6.31938 11.7627C5.59992 11.282 5.03916 10.5987 4.70803 9.79925C4.37689 8.99982 4.29025 8.12016 4.45906 7.27149C4.62787 6.42282 5.04455 5.64327 5.65641 5.03142C6.26826 4.41956 7.04781 4.00289 7.89648 3.83408C8.74515 3.66527 9.62481 3.75191 10.4242 4.08304C11.2237 4.41417 11.9069 4.97493 12.3877 5.69439C12.8684 6.41386 13.125 7.25972 13.125 8.12501C13.1237 9.28493 12.6623 10.397 11.8421 11.2171C11.0219 12.0373 9.90992 12.4987 8.75 12.5ZM15 5.62501C14.8764 5.62501 14.7555 5.58836 14.6528 5.51968C14.55 5.451 14.4699 5.35339 14.4226 5.23919C14.3753 5.12498 14.3629 4.99932 14.387 4.87808C14.4111 4.75684 14.4706 4.64548 14.5581 4.55807C14.6455 4.47066 14.7568 4.41114 14.8781 4.38702C14.9993 4.3629 15.125 4.37528 15.2392 4.42259C15.3534 4.46989 15.451 4.55 15.5197 4.65278C15.5883 4.75556 15.625 4.8764 15.625 5.00001C15.625 5.16577 15.5592 5.32474 15.4419 5.44195C15.3247 5.55916 15.1658 5.62501 15 5.62501Z"
            fill="black"
          />
        </svg>
      )

    case ButtonIcon.MIRROR:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <defs>
            <linearGradient id="mirrorGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF9711" />
              <stop offset="33%" stopColor="#FF538E" />
              <stop offset="66%" stopColor="#B662FF" />
              <stop offset="100%" stopColor="#1FA2FC" />
            </linearGradient>
          </defs>
          {/* Ornate hand mirror with decorative frame */}
          <circle cx="12" cy="12" r="7" stroke="url(#mirrorGradient)" strokeWidth="2" fill="none" />
          {/* Inner reflection shine */}
          <path
            d="M8 9 Q9 10 10 9"
            stroke="url(#mirrorGradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
            opacity="0.6"
          />
          {/* Decorative frame details */}
          <circle
            cx="12"
            cy="12"
            r="5.5"
            stroke="url(#mirrorGradient)"
            strokeWidth="1"
            fill="none"
            opacity="0.5"
          />
          {/* Handle with grip */}
          <path
            d="M12 19 L12 22"
            stroke="url(#mirrorGradient)"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <line x1="10" y1="20" x2="14" y2="20" stroke="url(#mirrorGradient)" strokeWidth="1.5" />
          <line x1="10" y1="21" x2="14" y2="21" stroke="url(#mirrorGradient)" strokeWidth="1.5" />
        </svg>
      )

    case ButtonIcon.SPARKLE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={svgStyle}
        >
          <defs>
            <linearGradient id="sparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF9711" />
              <stop offset="33%" stopColor="#FF538E" />
              <stop offset="66%" stopColor="#B662FF" />
              <stop offset="100%" stopColor="#1FA2FC" />
            </linearGradient>
          </defs>
          <path
            d="M12 2l2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5L12 2z"
            stroke="url(#sparkleGradient)"
            strokeWidth="2"
            fill="url(#sparkleGradient)"
          />
          <path
            d="M6 6l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z"
            stroke="url(#sparkleGradient)"
            strokeWidth="1"
            fill="url(#sparkleGradient)"
          />
        </svg>
      )

    default:
      return null
  }
}
